import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, useContext, useRoute } from '@nuxtjs/composition-api';
import { buildOAuthUrl } from '@/components/common/SignUpModal/utils';
import SignUpSocialButtons from '@/components/common/SignUpModal/SignUpSocialButtons/SignUpSocialButtons.vue';
import SignUpFooter from '@/components/common/SignUpModal/SignUpFooter/SignUpFooter.vue';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import { isUserInsideExternalApp as isUserInsideExternalAppUtil } from '@/utils/externalRedirections';

type WarRoomGateWidgetProps = {
  // Title supports html, because we need to add line break sometimes
  title?: string;
  // Gate in memeber post has different styles
  // - fading on background
  // - overlay the comment above
  isMemberPost?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'GateWidget',
  props: {
    title: { default: 'Join the community built by salespeople, for salespeople' },
    isMemberPost: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { title: string, isMemberPost: boolean };



const { $device, $analytics, $modal } = useContext();
const route = useRoute();

const isUserInsideExternalApp = ref(false);

onMounted(() => {
  isUserInsideExternalApp.value = isUserInsideExternalAppUtil(
    document.referrer,
    navigator.userAgent,
    $device.isWebView,
  );
});

function loginWithLinkedin() {
  $analytics?.logEvent('war-room__gate-widget__linkedin-button__click', {
    memberPost: props.isMemberPost,
  });
  window.location.assign(buildOAuthUrl('linkedin', 'signUp', route.value));
}

function loginWithGoogle() {
  $analytics?.logEvent('war-room__gate-widget__google-button__click', {
    memberPost: props.isMemberPost,
  });
  window.location.assign(buildOAuthUrl('google', 'signUp', route.value));
}

function navigateToSignIn() {
  $analytics?.logEvent('war-room__gate-widget__login-link__click', {
    memberPost: props.isMemberPost,
  });
  $modal.showWithRoute('SIGN_IN_MODAL');
}

function navigateToSignUp() {
  $modal.showWithRoute('SIGN_UP_MODAL');
}

return { __sfc: true,props, $device, $analytics, $modal, route, isUserInsideExternalApp, loginWithLinkedin, loginWithGoogle, navigateToSignIn, navigateToSignUp, SignUpSocialButtons, SignUpFooter, BravadoButtonV3 }
}

})